import {
  useCloseWipMutation,
  useLockWipMutation,
  useOpenWipMutation,
  useUnlockWipMutation,
} from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { observer } from "mobx-react-lite";
import Actions from "../../Actions";
import type { SubRow } from "../../models";
import { useStore } from "../../Store";

interface SubRowActionsProps {
  subRow: SubRow;
}

const SubRowActions = ({ subRow }: SubRowActionsProps) => {
  const store = useStore();

  const [lockWipMutation, { loading: lockLoading }] = useLockWipMutation({
    variables: {
      id: subRow.work_in_progress_id,
    },
    ...onError(),
    onCompleted() {
      store.refetchProjectsWip();
    },
  });

  const [unlockWipMutation, { loading: unlockLoading }] = useUnlockWipMutation({
    variables: {
      id: subRow.work_in_progress_id,
    },
    ...onError(),
    onCompleted() {
      store.refetchProjectsWip();
    },
  });

  const [openWipMutation, { loading: openLoading }] = useOpenWipMutation({
    variables: {
      id: subRow.work_in_progress_id,
    },
    ...onError(),
    onCompleted() {
      store.refetchProjectsWip();
    },
  });

  const [closeWipMutation, { loading: closeLoading }] = useCloseWipMutation({
    variables: {
      id: subRow.work_in_progress_id,
    },
    ...onError(),
    onCompleted() {
      store.refetchProjectsWip();
    },
  });

  return (
    <Actions
      size="sm"
      isClosed={subRow.is_closed}
      isLocked={subRow.is_locked}
      onOpen={openWipMutation}
      openLoading={openLoading}
      onClose={closeWipMutation}
      closeLoading={closeLoading}
      onLock={lockWipMutation}
      lockLoading={lockLoading}
      onUnlock={unlockWipMutation}
      unlockLoading={unlockLoading}
    />
  );
};

export default observer(SubRowActions);
